<template>
  <div class="zone-availability" v-if="zone && zone.available_days">
    <h5 class="zone-availability-title">{{ $t('zoneAvailability.title') }}</h5>

    <div class="zone-availability-switch">
      <p-switch :name="'zaActive_' + uid" v-model="zone.active" type="success"></p-switch>
      <label>{{ $t('zoneAvailability.active') }}</label>
    </div>
    <small class="text-muted zone-availability-help">{{ $t('zoneAvailability.activeHelp') }}</small>

    <div class="zone-availability-switch">
      <p-switch :name="'zaSchedule_' + uid" v-model="zone.schedule_enabled" type="success"></p-switch>
      <label>{{ $t('zoneAvailability.scheduleEnabled') }}</label>
    </div>
    <small class="text-muted zone-availability-help">{{ $t('zoneAvailability.scheduleEnabledHelp') }}</small>

    <template v-if="zone.schedule_enabled">
      <div class="row" v-for="(day, dayIdx) in zone.available_days" :key="day.day" style="display:flex; align-items:flex-start; margin-bottom:20px;">
        <div class="col-md-6">
          <div class="row" style="margin-bottom:12px;">
            <div class="col-md-3 padd in-inline-160">
              <div class="checkbox">
                <input type="checkbox" :id="'za_' + uid + '_' + day.day" v-model="day.open">
                <label :for="'za_' + uid + '_' + day.day">{{ $t('days.' + day.day) | capitalize }}</label>
              </div>
            </div>
            <div class="col-md-9 padd">
              from
              <el-time-select :class="{'is-invalid': isInvalid(day, 0, day.open_from, day.open_to)}" :disabled="!day.open" placeholder="Select time" v-model="day.open_from" :picker-options="pickerOptions"></el-time-select>
              to
              <el-time-select :class="{'is-invalid': isInvalid(day, 0, day.open_from, day.open_to)}" :disabled="!day.open" placeholder="Select time" v-model="day.open_to" :picker-options="pickerOptions"></el-time-select>
            </div>
          </div>
          <div class="row intervals" v-if="day.intervals">
            <template v-for="(interval, intervalKey) in day.intervals">
              <div class="col-md-3 padd in-inline-160"></div>
              <div class="col-md-9 padd" style="margin-bottom:12px;">
                from
                <el-time-select :class="{'is-invalid': isInvalid(day, intervalKey + 1, interval.open_from, interval.open_to)}" :disabled="!day.open" placeholder="Select time" v-model="interval.open_from" :picker-options="pickerOptions"></el-time-select>
                to
                <el-time-select :class="{'is-invalid': isInvalid(day, intervalKey + 1, interval.open_from, interval.open_to)}" :disabled="!day.open" placeholder="Select time" v-model="interval.open_to" :picker-options="pickerOptions"></el-time-select>
                <button class="btn btn-sm btn-danger" style="width:35px; height:35px; padding:0; margin-left:8px;" @click.prevent="deleteInterval(dayIdx, intervalKey)"><i class="ti-close"></i></button>
              </div>
            </template>
          </div>
          <small class="text-danger" v-if="day.open && hasOverlap(day)">{{ $t('zoneAvailability.overlap') }}</small>
        </div>
        <div class="col-md-2">
          <button class="btn add" :disabled="!day.open" @click.prevent="addInterval(dayIdx)" :title="$t('general.add')">
            <img src="/static/img/icons/add.png"> {{ $t('general.add') }}
          </button>
        </div>
      </div>
      <p class="text-danger" v-if="showErrors && error">{{ error }}</p>
    </template>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import { TimeSelect } from 'element-ui'
import PSwitch from 'src/components/UIComponents/Switch.vue'
import { ensureZoneAvailability, overlappingIntervalKeys, intervalPairInvalid, zoneAvailabilityError } from './zoneAvailability'

Vue.use(TimeSelect)

// Active/inactive switch + optional weekly hour schedule of a delivery zone.
// Edits the passed zone object in place (same convention as DeliveryGoogleMaps).
export default {
  name: 'zone-availability-editor',
  components: {
    PSwitch
  },
  props: {
    zone: { type: Object, required: true },
    // highlight errors (after the parent tried to save)
    showErrors: { type: Boolean, default: false }
  },
  data () {
    return {
      uid: this._uid,
      pickerOptions: { start: '00:00', step: '00:15', end: '24:00' }
    }
  },
  computed: {
    error () {
      return zoneAvailabilityError(this.zone, this.$t.bind(this))
    }
  },
  watch: {
    zone: {
      immediate: true,
      handler (zone) {
        ensureZoneAvailability(this, zone)
      }
    }
  },
  methods: {
    hasOverlap (day) {
      return Object.keys(overlappingIntervalKeys(day)).length > 0
    },
    isInvalid (day, key, from, to) {
      if (!day.open) return false
      if (overlappingIntervalKeys(day)[key]) return true
      return this.showErrors && intervalPairInvalid(from, to)
    },
    addInterval (dayIdx) {
      const day = this.zone.available_days[dayIdx]
      if (!day.intervals) this.$set(day, 'intervals', [])
      day.intervals.push({ open_from: '', open_to: '' })
    },
    deleteInterval (dayIdx, intervalKey) {
      this.zone.available_days[dayIdx].intervals.splice(intervalKey, 1)
    }
  }
}
</script>

<style scoped>
.zone-availability {
  margin: 15px 0;
  padding: 15px;
  border: 1px solid #e3e3e3;
  border-radius: 6px;
}
.zone-availability-title {
  margin-top: 0;
  font-weight: 600;
}
.zone-availability-switch {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.zone-availability-switch label {
  margin: 0 0 0 10px;
}
.zone-availability-help {
  display: block;
  margin-bottom: 10px;
}
/* el-time-select is a wrapper component; reach its inner input */
.is-invalid >>> input,
.is-invalid >>> .el-input__inner {
  border-color: #dc3545 !important;
  background-color: #fff5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/DeliveryPreferences/ZoneAvailabilityEditor.vue